// eslint-disable-next-line no-unused-vars
const FUTURE_CHARTS_COMMAND_PKG = {
    navTitle: "Futures Charts",
    routerName: "FuturesChartsDocs",
    commandsDescription: "DJIA, Crude, Gold, etc...",


    commandList: [
        {
            title: "Crude Oil WTI",
            routerRef: "chart_cl",
            commandString: "!chart_cl",
            description: "Crude Oil WTI 5m Futures Graph",
            parameters: ["none"],
            examples: [
                "!chart_cl"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "DJIA",
            routerRef: "chart_djfut",
            commandString: "!chart_djfut",
            description: "5m Futures for DJIA",
            parameters: ["none"],
            examples: [
                "!chart_djfut"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Gold",
            routerRef: "chart_gold",
            commandString: "!chart_gold",
            description: "Gold Futures",
            parameters: ["none"],
            examples: [
                "!chart_gold"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "NASDAQ",
            routerRef: "chart_nasfut",
            commandString: "!chart_nasfut",
            description: "5m Futures for NASDAQ",
            parameters: ["none"],
            examples: [
                "!chart_nasfut"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Nikkei 225",
            routerRef: "chart_nkdfut",
            commandString: "!chart_nkdfut",
            description: "5m Futures for Nikkei 225",
            parameters: ["none"],
            examples: [
                "!chart_nkdfut"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Crude Oil",
            routerRef: "chart_oil",
            commandString: "!chart_oil",
            description: "Crude Oil Daily Graph",
            parameters: ["none"],
            examples: [
                "!chart_oil"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Russel - IWM",
            routerRef: "chart_rusfut",
            commandString: "!chart_rusfut",
            description: "5m Futures for Russel",
            parameters: ["none"],
            examples: [
                "!chart_rusfut"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "Silver",
            routerRef: "chart_silver",
            commandString: "!chart_silver",
            description: "Silver Futures",
            parameters: ["none"],
            examples: [
                "!chart_silver"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "ES",
            routerRef: "chart_spfut",
            commandString: "!chart_spfut",
            description: "5m Futures for S&P 500",
            parameters: ["none"],
            examples: [
                "!chart_spfut"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
        {
            title: "VIX",
            routerRef: "chart_vix",
            commandString: "!chart_vix",
            description: "5m Futures for VIX",
            parameters: ["none"],
            examples: [
                "!chart_vix"
            ],
            type: "Futures Charts", 
            shortcuts: ["none"]
        },
    ]
}

export {FUTURE_CHARTS_COMMAND_PKG};